import { useEffect, useState } from 'react'
import { PAYMENT_METHODS, VALIDATION_MESSAGE } from '../../utils/constants'
import { translatePaymentMethod, translatePaymentType } from '../../utils/translator'
import Input from '../../components/Input'
import Textarea from '../../components/Textarea'
import Button from '../../components/Button'
import AccountPicker from '../../components/account/AccountPicker'
import { ACCOUNT_PATH, getPageAccounts } from '../../api/accountApi'
import { useApiProgress } from '../../hooks/ApiProgress'
import useFirstRender from '../../hooks/FirstRender'
import { useParams } from 'react-router-dom'
import { useCloseTab } from '../../components/tabs/TabsContext'
import { addPayment } from '../../api/paymentApi'
import { toast } from 'react-toastify'
import { CHEQUE_PATH, addCheque, getPageCheques } from '../../api/chequeApi'
import ChequePicker from '../../components/cheque/ChequePicker'
import ChequeAddModal from '../../components/cheque/ChequeAddModal'
import { IoMdOpen } from "react-icons/io";
import ChequeCard from '../../components/cheque/ChequeCard'
import { getCustomerById } from '../../api/customerApi'

const CustomerPaymentPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const closeTab = useCloseTab()
    const { id } = useParams();
    const [method, setMethod] = useState("CASH")
    const [type, setType] = useState()
    const isFirstRender = useFirstRender()

    const [paymentDate, setPaymentDate] = useState("")
    const [amount, setAmount] = useState("")
    const [description, setDescription] = useState("")
    const [account, setAccount] = useState()
    const [customer, setCustomer] = useState()
    const [cheque, setCheque] = useState()
    const [isOpenChequeModal, setIsOpenChequeModal] = useState(false)

    const [chequeErrors, setChequeErrors] = useState({})

    const [accountPage, setAccountPage] = useState({
        content: []
    });
    const [chequePage, setChequePage] = useState({
        content: []
    });

    const [accountQuery, setAccountQuery] = useState('')
    const [chequeQuery, setChequeQuery] = useState('')

    const [searchTimerAccount, setSearchTimerAccount] = useState();
    const [searchTimerCheque, setSearchTimerCheque] = useState();
    const pendingApiCallAccount = useApiProgress('get', `${ACCOUNT_PATH}/page`, false)
    const pendingApiCallCheque = useApiProgress('get', `${CHEQUE_PATH}/page`, false)

    const [errors, setErrors] = useState({})

    const searchingAccount = async (params) => {
        if (searchTimerAccount) clearTimeout(searchTimerAccount);
        let timer = setTimeout(() => {
            getPageAccounts(params)
                .then(res => {
                    setAccountPage(res.data)
                })
        }, 500);
        setSearchTimerAccount(timer);
    }

    const searchingCheque = async (params) => {
        if (searchTimerCheque) clearTimeout(searchTimerCheque);
        let timer = setTimeout(() => {
            getPageCheques(params)
                .then(res => {
                    setChequePage(res.data)
                })
        }, 500);
        setSearchTimerCheque(timer);
    }

    const onClickLoadMoreAccount = () => {
        if (!accountPage.last) {
            loadAccounts({ search: accountQuery, lastId: accountPage.content[accountPage.content.length - 1]?.id })
        }
    }

    const onClickLoadMoreCheque = () => {
        if (!chequePage.last) {
            loadCheques({ search: chequeQuery, lastId: chequePage.content[chequePage.content.length - 1]?.id })
        }
    }

    const loadAccounts = (params) => {
        !pendingApiCallAccount &&
            getPageAccounts(params)
                .then(res => {
                    setAccountPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const loadCheques = (params) => {
        !pendingApiCallCheque &&
            getPageCheques(params)
                .then(res => {
                    setChequePage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    useEffect(() => {
        !isFirstRender && searchingAccount({ search: accountQuery })
    }, [accountQuery])

    useEffect(() => {
        !isFirstRender && searchingCheque({ search: chequeQuery })
    }, [chequeQuery])

    useEffect(() => {
        loadAccounts({ size: 20 })
        loadCheques({ size: 20 })
        getCustomerById(id).then(res => setCustomer(res.data))
    }, [])

    const onSubmit = () => {
        const body = {
            customerId: id,
            type,
            method,
            paymentDate,
            amount,
            description,
            accountId: account?.id,
            currency: customer?.currency,
            chequeSerialNumber: cheque?.serialNumber
        }
        addPayment(body)
            .then(res => {
                toast.success('Ödeme kaydedildi')
                closeTab()

            }).catch(err => {
                setErrors(err.response.data.validationErrors)
                toast.error(VALIDATION_MESSAGE)
            })
    }

    useEffect(() => {
        setErrors(prevState => ({ ...prevState, accountId: null }))
    }, [account])

    useEffect(() => {
        setErrors(prevState => ({ ...prevState, type: null }))
    }, [type])

    useEffect(() => {
        setErrors(prevState => ({ ...prevState, paymentDate: null }))
    }, [paymentDate])

    useEffect(() => {
        setErrors(prevState => ({ ...prevState, amount: null }))
    }, [amount])

    const onClickSubmitCheque = (newCheque) => {
        addCheque(newCheque)
            .then(res => {
                setCheque(res.data)
                setIsOpenChequeModal(false)
                toast.success('Çek kaydedildi')
                setAmount(res.data.amount)
            }).catch(err => {
                setChequeErrors(err.response.data.validationErrors)
                toast(VALIDATION_MESSAGE)
            })
    }

    return (
        <div>
            <div className='mb-5'>
                <label className='text-xl'>Yeni Ödeme</label>
            </div>
            <div className='grid grid-cols-1 place-items-center'>
                <div className='col-span-6 w-96'>
                    <div className='mb-5 shadow-lg border p-3 rounded-md text-sm'>
                        <label className='block'>Müşteri Adı : {customer?.code} </label>
                        <label className='block'>Müşteri Adı : {customer?.name} </label>
                        <label className='block'>Adres : {customer?.address} </label>
                        <label className='block'>Telefon : {customer?.phone} </label>

                    </div>
                    <div className='flex gap-x-3 mb-5'>
                        {
                            PAYMENT_METHODS.map((m, index) => (
                                <div key={index} className={`${m === method ? 'bg-blue-600 text-white' : ""} p-2 hover:bg-blue-600 hover:text-white cursor-pointer rounded-sm duration-150`} onClick={() => setMethod(m)}>
                                    {translatePaymentMethod(m)}
                                </div>
                            ))
                        }
                    </div>
                    {
                        (method === "CASH" || method === "CREDIT_CARD" || method === "BANK_TRANSFER") &&
                        <>
                            <div className='mb-3'>
                                <div className='flex gap-x-5'>

                                    <label className='flex gap-x-3'>
                                        <input type="radio" value="option1" checked={type === 'PAYMENT'} onClick={() => setType('PAYMENT')} />
                                        Ödeme
                                    </label>
                                    <label className='flex gap-x-3'>
                                        <input type="radio" value="option1" checked={type === 'COLLECTION'} onClick={() => setType('COLLECTION')} />
                                        Tahsilat
                                    </label>
                                </div>
                                {errors.type && <label className='text-red-700 text-sm'>{errors.type} </label>}
                            </div>
                            <div>
                                <Input
                                    label='Ödeme Tarihi'
                                    type='date'
                                    name='paymentDate'
                                    onChange={(e) => setPaymentDate(e.target.value)}
                                    value={paymentDate}
                                    error={errors.paymentDate}
                                />
                            </div>
                            <div>
                                <Input
                                    label={`Miktar (${customer?.currency})`}
                                    type='number'
                                    name='amount'
                                    onChange={(e) => setAmount(e.target.value)}
                                    value={amount}
                                    placeholder={`${translatePaymentType(type)} miktarı girin...`}
                                    error={errors.amount}
                                />
                            </div>
                            <div>
                                <Textarea
                                    label='Açıklama'
                                    type='text'
                                    name='description'
                                    onChange={(e) => setDescription(e.target.value)}
                                    value={description}
                                    placeholder="Açıklama girin..."
                                />
                            </div>
                            <div>
                                <AccountPicker
                                    label='Hesap'
                                    pendingApiCall={pendingApiCallAccount}
                                    state={account}
                                    setState={(value) => setAccount(value)}
                                    query={accountQuery}
                                    setQuery={setAccountQuery}
                                    error={errors.accountId}
                                    page={accountPage}
                                    setErrors={prevState => ({ ...prevState, accountId: undefined })}
                                    onClickClear={() => setAccount()}
                                    onClickLoadMore={() => onClickLoadMoreAccount()}
                                />
                            </div>
                            <Button
                                text='Kaydet'
                                variant='green'
                                onClick={onSubmit}
                            />
                        </>
                    }
                    {
                        method === 'CHEQUE' &&
                        <div>
                            <div className='mb-3'>
                                <div className='flex gap-x-5'>
                                    <label className='flex gap-x-3'>
                                        <input type="radio" value="option1" checked={type === 'PAYMENT'} onClick={() => setType('PAYMENT')} />
                                        Ödeme
                                    </label>
                                    <label className='flex gap-x-3'>
                                        <input type="radio" value="option1" checked={type === 'COLLECTION'} onClick={() => setType('COLLECTION')} />
                                        Tahsilat
                                    </label>
                                </div>
                                {errors.type && <label className='text-red-700 text-sm'>{errors.type} </label>}
                            </div>
                            <div>
                                <Input
                                    label='Ödeme Tarihi'
                                    type='date'
                                    name='paymentDate'
                                    onChange={(e) => setPaymentDate(e.target.value)}
                                    value={paymentDate}
                                    error={errors.paymentDate}
                                />
                            </div>
                            {
                                type === 'PAYMENT' &&
                                <>

                                    <ChequePicker
                                        label='Çek'
                                        pendingApiCall={pendingApiCallCheque}
                                        state={cheque}
                                        setState={(value) => {
                                            setCheque(value)
                                            setAmount(value.amount)
                                        }}
                                        query={chequeQuery}
                                        setQuery={setChequeQuery}
                                        error={errors.chequeId}
                                        page={chequePage}
                                        setErrors={prevState => ({ ...prevState, chequeId: undefined })}
                                        onClickClear={() => {
                                            setCheque()
                                            setAmount("")
                                        }}
                                        onClickLoadMore={() => onClickLoadMoreCheque()}
                                    />
                                    <Input
                                        label={`Miktar (${customer?.currency})`}
                                        type='number'
                                        name='amount'
                                        onChange={(e) => setAmount(e.target.value)}
                                        value={amount}
                                        error={errors.amount}
                                        disabled
                                    />
                                    <AccountPicker
                                        label='Hesap'
                                        pendingApiCall={pendingApiCallAccount}
                                        state={account}
                                        setState={(value) => setAccount(value)}
                                        query={accountQuery}
                                        setQuery={setAccountQuery}
                                        error={errors.accountId}
                                        page={accountPage}
                                        setErrors={prevState => ({ ...prevState, accountId: undefined })}
                                        onClickClear={() => setAccount()}
                                        onClickLoadMore={() => onClickLoadMoreAccount()}
                                    />
                                    <Textarea
                                        label='Açıklama'
                                        type='text'
                                        name='description'
                                        onChange={(e) => setDescription(e.target.value)}
                                        value={description}
                                        placeholder="Açıklama girin..."
                                    />
                                    <Button
                                        text='Kaydet'
                                        variant='green'
                                        onClick={onSubmit}
                                    />
                                </>
                            }
                            {
                                type === 'COLLECTION' &&
                                <>
                                    {
                                        !cheque &&
                                        <div className='mb-5 flex items-center gap-x-2 cursor-pointer' onClick={() => setIsOpenChequeModal(true)} >
                                            <label className='text-blue-700 border-blue-700 cursor-pointer'>Yeni çek</label>
                                            <IoMdOpen className='text-blue-700' />
                                        </div>
                                    }
                                    {
                                        cheque &&
                                        <ChequeCard
                                            cheque={cheque}
                                        />
                                    }
                                    <Input
                                        label={`Miktar (${customer?.currency})`}
                                        type='number'
                                        name='amount'
                                        onChange={(e) => setAmount(e.target.value)}
                                        value={amount}
                                        error={errors.amount}
                                        disabled
                                    />
                                    <AccountPicker
                                        label='Hesap'
                                        pendingApiCall={pendingApiCallAccount}
                                        state={account}
                                        setState={(value) => setAccount(value)}
                                        query={accountQuery}
                                        setQuery={setAccountQuery}
                                        error={errors.accountId}
                                        page={accountPage}
                                        setErrors={prevState => ({ ...prevState, accountId: undefined })}
                                        onClickClear={() => setAccount()}
                                        onClickLoadMore={() => onClickLoadMoreAccount()}
                                    />
                                    <Textarea
                                        label='Açıklama'
                                        type='text'
                                        name='description'
                                        onChange={(e) => setDescription(e.target.value)}
                                        value={description}
                                        placeholder="Açıklama girin..."
                                    />
                                    <Button
                                        text='Kaydet'
                                        variant='green'
                                        onClick={onSubmit}
                                    />
                                </>
                            }
                        </div>
                    }
                </div>
            </div>
            <ChequeAddModal
                isOpen={isOpenChequeModal}
                closeModal={() => setIsOpenChequeModal(false)}
                onClick={(newCheque) => onClickSubmitCheque(newCheque)}
                errors={chequeErrors}
                setErrors={setChequeErrors}
            />
        </div>
    )
}

export default CustomerPaymentPage